<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="tab-panel-content-wrapper">
    <ng-container *ngIf="options?.length; else noOptions">
      <div class="service-categories-grid">
        <div class="service-category-column">
          <div class="tab-panel-input-wrapper service-category-item" *ngFor="let opt of leftOptions">
            <label class="field-input-label tab-input-label">{{ opt.label }}</label>
            <p-inputSwitch
              [ngModel]="isSelected(opt.value)"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="toggleCategory(opt.value, $event.checked)"
            ></p-inputSwitch>
          </div>
        </div>

        <div class="service-category-column">
          <div class="tab-panel-input-wrapper service-category-item" *ngFor="let opt of centerOptions">
            <label class="field-input-label tab-input-label">{{ opt.label }}</label>
            <p-inputSwitch
              [ngModel]="isSelected(opt.value)"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="toggleCategory(opt.value, $event.checked)"
            ></p-inputSwitch>
          </div>
        </div>

        <div class="service-category-column">
          <div class="tab-panel-input-wrapper service-category-item" *ngFor="let opt of rightOptions">
            <label class="field-input-label tab-input-label">{{ opt.label }}</label>
            <p-inputSwitch
              [ngModel]="isSelected(opt.value)"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="toggleCategory(opt.value, $event.checked)"
            ></p-inputSwitch>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noOptions>
      <div class="tab-panel-input-wrapper">
        <span>No service categories available.</span>
      </div>
    </ng-template>
  </div>
</form>
